module.exports = __webpack_public_path__ + "img/logo-white.f1858031.svg";